import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Card = ({ children, title, subtitle, footer, variant = 'default', size, className = '', ...props }) => {
  const variantClasses = {
    default: 'shadow-md',
    outlined: 'border border-gray-300 shadow-none',
    raised: 'shadow-lg',
    flat: 'bg-transparent shadow-none border-none',
  }
  const sizeClasses = {
    default: '300px',
    small: '150px',
    large: '500px',
  }

  return (
    <div
      className={clsx(
        'mt-12 left-[260px] bg-white rounded-lg overflow-hidden transition-transform duration-200',
        'hover:translate-y-[-2px] hover:shadow-sm',
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
      {...props}
    >
      {title && (
        <header className="top-2 border-border">
          <h4 className="text-md font-bold text-black mb-2">{title}</h4>
          {subtitle && <p className="text-sm text-secondary bg-primary/30 mt-2 p-3 w-1/2">{subtitle}</p>}
        </header>
      )}
      <div className="flex-1">{children}</div>
      {footer && <footer className="p-4 bg-light border-t border-border text-right">{footer}</footer>}
    </div>
  )
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  footer: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
}

export default Card
